(ns ycweb.app.website.dlp.widgets.infocards
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc info-card < rum/reactive
  [app-atom
   {:keys [sidebarexists]}
   {:keys [properties]}
   {:keys
    [picture_public_id image_alt_text title mutecard description listitems
     button_text button_url]}]
  (let [{:info-cards/keys [num-columns brand-card-styles]} properties
        num-of-cols (trf/tonumber num-columns)

        card
        [:div
         [:figure.card__hero
          (web-common/lazy-image app-atom
            picture_public_id
            {:class ["card__image"]}
            {:w (if (and (= num-of-cols 3) (not sidebarexists)) 318 233)
             :q "auto"
             :alt (if (not (empty? image_alt_text)) image_alt_text title)})
          (when (trf/toboolean mutecard)
            [:div.card__status-sticker-wrapper
             [:div
              {:class (u/bem :card-sticker [:status])}
              "Muted"]])]
         (when (or (u/presence title) (u/presence description) (u/presence listitems))
           [:div
            {:class
             (u/bem :card__content-wrapper
               (when
                 (or
                   (and (empty? description) (empty? listitems))
                   (= num-of-cols 6))
                 [:title-only]))}
            [:div.card__content
             (when title
               [:h2
                {:class
                 (u/bem :card__title
                   [(when (or sidebarexists (= num-of-cols 4) (= num-of-cols 6))
                      :small)
                    (when
                      (or
                        (and (empty? description) (empty? listitems) (empty? button_text))
                        (= num-of-cols 6))
                      :center)])
                 :dangerouslySetInnerHTML
                 {:__html title}}])
             (when (and (not brand-card-styles) (not (= num-of-cols 6)))
               (list
                 (when (u/presence description)
                   [:p
                    {:class
                     (u/bem :info-card__description
                       (when (or sidebarexists (= num-of-cols 4))
                         [:small]))
                     :dangerouslySetInnerHTML
                     {:__html description}}])
                 (when (u/presence listitems)
                   [:ul
                    {:class
                     (u/bem :info-card-list
                       (when (or sidebarexists (= num-of-cols 4))
                         [:small]))
                     :dangerouslySetInnerHTML
                     {:__html listitems}}])))]
            (when
              (and
                (nil? brand-card-styles)
                (u/presence button_text)
                (not (= num-of-cols 6)))
              [:div.info-card__footer
               (buttons/button-web button_text
                 {:type :span-button
                  :style :light
                  :size :small})])])]]

    (cond
      button_url
      [:a.u-block-link
       (merge
         (when (str/starts-with? button_url "#")
           (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace button_url #"\#" ""))))
         {:href button_url})
       card]

      :else
      card)))

(rum/defc info-cards < rum/reactive [app-atom page {:keys [properties] :as component}]
  (let [{:info-cards/keys
         [on-page-link-id title align-cards-centre?
          cards num-columns brand-card-styles
          show-content? heading-type]}
        properties

        num-of-cols (trf/tonumber num-columns)

        card-list
        (if (map? cards)
          (vals cards)
          cards)]

    (when show-content?
      [:div.yc-section
       {:id on-page-link-id}
       (when title
         (headings/heading title
           {:type (keyword (str "h" heading-type))
            :size :default
            :center true
            :dangerouslySetInnerHTML? true}))
       (into
         [:div
          {:class
           (u/bem :flex-grid-group
             [(when-not align-cards-centre? :align-left)])}]
         (when-not (empty? cards)
           (->>
             card-list
             (map
               (fn [{:keys [mutecard] :as card}]
                 (when-not (trf/toboolean mutecard)
                   [:div
                    {:class
                     (u/bem :flex-grid-block
                       (cond
                         (= num-of-cols 6)
                         [:t-1-2 :ml-1-3 :l-1-6]

                         (= num-of-cols 4)
                         [:t-1-2 :ml-1-4]

                         :else
                         [:t-1-2 :ml-1-3]))}
                    [:article.flex-grid-content
                     {:class
                      (u/bem :card
                        (when (trf/toboolean mutecard)
                          [:is-disabled :no-hover])
                        (cond
                          (u/presence brand-card-styles)
                          :brand-card

                          :else
                          :info-card))}

                     (info-card app-atom page component card)]]))))))])))
